import styled from "styled-components";
import colors from "../../styles/colors";

export const Container = styled.button`
  background: ${colors.primaryLight};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${colors.primaryLightHover};
  }

  &:disabled {
    background: ${colors.primaryLightDisabled};
  }
`;
